import { isFeatureEnabled } from 'owa-feature-flags';
import type { Suggestion } from 'owa-userdataservice';
import {
    SonoraEntityType,
    SonoraFile,
    SonoraFileSuggestion,
    SonoraFileSuggestionSourceType,
} from 'owa-editor-sonora-types';
import { trace } from 'owa-trace';

export default function parseFileSuggestions(
    suggestion: Suggestion
): SonoraFileSuggestion | undefined {
    try {
        const data = JSON.parse(suggestion.encodedJsonData);

        if (data) {
            let fileSuggestions = data.map(
                userDataInfo =>
                    <SonoraFile>{
                        type: SonoraEntityType.File,
                        sourceType: getSuggestionSourceType(userDataInfo.FileSourceType),
                        fileName: userDataInfo.FileName,
                        hitFileName: userDataInfo.HitFileName,
                        fileExtension: userDataInfo.FileExtension,
                        fileSize: userDataInfo.FileSize,
                        url: userDataInfo.Url,
                        lastAccessDateTime: userDataInfo.LastAccessDateTime,
                        lastModifiedDateTime: userDataInfo.LastModifiedDateTime,
                        createdDateTime: userDataInfo.CreatedDateTime,
                        attachmentId: userDataInfo.AttachmentId,
                        itemId: userDataInfo.ItemId,
                        subject: userDataInfo.Subject,
                    }
            );

            if (!isFeatureEnabled('honeybee-sonora-mailboxFile')) {
                fileSuggestions = fileSuggestions.filter(
                    suggestion =>
                        suggestion.sourceType !== SonoraFileSuggestionSourceType.ClassicAttachment
                );
            }

            return {
                suggestions: fileSuggestions,
                logicalId: suggestion?.logicalId,
                traceId: suggestion?.traceId,
            };
        }
    } catch (error) {
        trace.warn(`[HoneybeeSonora|parseFileSuggestion] Error: ${error}`);
    }

    return undefined;
}

function getSuggestionSourceType(fileSourceType: string): SonoraFileSuggestionSourceType {
    switch (fileSourceType) {
        case 'ClassicAttachment':
            return SonoraFileSuggestionSourceType.ClassicAttachment;
        case 'OneDriveForBusiness':
            return SonoraFileSuggestionSourceType.OneDriveForBusiness;
        case 'SharepointOnline':
            return SonoraFileSuggestionSourceType.SharepointOnline;
        default:
            return SonoraFileSuggestionSourceType.Undefined;
    }
}
